module.exports = __webpack_public_path__ + "static/media/featured-3-bed-en.f4e383ae.png";